import { useState, useEffect } from "react";

export default function Preloader() {
    const [loading, setLoading] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        // Check if it's the first load in this session
        const hasLoaded = sessionStorage.getItem("hasLoaded");

        if (hasLoaded) {
            setLoading(false);
            return;
        }

        const timer = setTimeout(() => {
            setFadeOut(true);
            setTimeout(() => {
                setLoading(false);
                sessionStorage.setItem("hasLoaded", "true");
            }, 600); // Wait for fade out animation
        }, 5000); // Show loader for 2 seconds

        return () => clearTimeout(timer);
    }, []);

    if (!loading) return null;

    return (
        <div
            className={`fixed inset-0 z-[9999] flex items-center justify-center bg-white transition-opacity duration-700 ease-in-out ${fadeOut ? "opacity-0 pointer-events-none" : "opacity-100"
                }`}
        >
            <div className="relative flex items-center justify-center">
                {/* Animated Ring */}
                <div className="absolute w-32 h-32 md:w-40 md:h-40 border-4 border-[#0a7d4f]/10 border-t-[#0a7d4f] rounded-full animate-spin"></div>

                {/* Pulsing Outer Circle */}
                <div className="absolute w-40 h-40 md:w-48 md:h-48 border border-[#c9a24d]/30 rounded-full animate-pulse-slow"></div>

                {/* Logo */}
                <div className="z-10 bg-white p-4 rounded-full shadow-sm">
                    <img
                        src="/assets/logo.png"
                        alt="Kaali Global Logo"
                        className="w-16 h-16 md:w-20 md:h-20 object-contain animate-subtle-pulse"
                    />
                </div>
            </div>

            <style>
                {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          @keyframes pulse-slow {
            0%, 100% { transform: scale(1); opacity: 0.3; }
            50% { transform: scale(1.1); opacity: 0.6; }
          }
          
          @keyframes subtle-pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }

          .animate-spin {
            animation: spin 1.5s linear infinite;
          }
          
          .animate-pulse-slow {
            animation: pulse-slow 3s ease-in-out infinite;
          }
          
          .animate-subtle-pulse {
            animation: subtle-pulse 2s ease-in-out infinite;
          }
        `}
            </style>
        </div>
    );
}
